export default "__VITE_ASSET__DvdP1gMg__"